export const API_PATH_ApiDeviceMgmtRegionUpdate = '/services/devices-mgtm/apiDeviceMgmtRegionUpdate';
